import VideojsPlayer from "./VideojsPlayer";
export default VideojsPlayer;
